import { Injectable } from '@angular/core';
import { ComponentItem, Page, Section, WebElement } from '../../state-management/model/interfaces/state.model';
import { WebsiteStateService } from '../../state-management/services/website-state.service';
import { ComponentTemplateService } from './component-template.service';
import { v4 as uuidv4 } from 'uuid';
import { ButtonActionType, ComponentType, ElementsType } from '../../state-management/model/enums/state.enums';

@Injectable({
  providedIn: 'root'
})
export class PageTemplateService {

  constructor(
    private websiteState: WebsiteStateService,
    private componentTemplateService: ComponentTemplateService
  ) { }


  public createTemplate(page: Page): void {
    const heroComponentSet = this.componentTemplateService.createHeroComponent();
    const navbarComponentId = "c6f25ff1-3c1e-4bcb-a903-b834d6853517"
    const heroSection = {
      "id": uuidv4(),
      "type": "hero",
      "order": 1,
      "components": [
        heroComponentSet.component.id,
        navbarComponentId
      ]
    }

    this.websiteState.addSection(heroSection.id, heroSection);
    this.websiteState.addComponent(heroComponentSet.component.id, heroComponentSet.component);
    heroComponentSet.elements.forEach((element) => {
      this.websiteState.addElement(element.id, element);
    });

    const featureBannerId = "27089719-5a31-4026-b893-8e91c1808652"
    const serviceComponents = [featureBannerId];
    for (let i = 0; i < 4; i++) {
      const serviceComponent = this.componentTemplateService.createServiceComponent(i);
      serviceComponents.push(serviceComponent.component.id);
      this.websiteState.addComponent(serviceComponent.component.id, serviceComponent.component);
      serviceComponent.elements.forEach((element) => {
        this.websiteState.addElement(element.id, element);
      });
    }
    const contactFormId = "6014e702-b4f1-4dfa-84db-49fd8275d224"
    serviceComponents.push(contactFormId);

    const serviceSection: Section = {
      "id": uuidv4(),
      "type": "section-services",
      "order": 1,
      "components": serviceComponents
    }
    this.websiteState.addSection(serviceSection.id, serviceSection);
    this.websiteState.addPage(page.id, { ...{ sections: [heroSection.id, serviceSection.id] }, ...page });
  }


  // Template-Methoden sind jetzt im ComponentTemplateService


}
